export default "__VITE_ASSET__7827bd4e__"